import { render } from "./VisitDetails.vue?vue&type=template&id=2a12a4de"
import script from "./VisitDetails?vue&type=script&lang=js&external"
export * from "./VisitDetails?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__